import { switchToggle } from './toggles'
import { cols } from 'variables'
import {
  SELECT_QUEUE_INDEX,
  INCREASE_COLS,
  DECREASE_COLS
} from '../actionTypes'
import { confirm } from './alerts'
import { queueSelector } from '../selectors/selectors'
import { firebaseAction } from '../utils'

export const selectQueueIndex = index => ({
  type: SELECT_QUEUE_INDEX,
  payload: { index }
})
export const increaseCols = () => ({ type: INCREASE_COLS })
export const decreaseCols = () => ({ type: DECREASE_COLS })

export const clearQueue = () =>
  firebaseAction((update, { dispatch, getState }) => {
    const action = () => {
      const state = getState()
      const queue = queueSelector(state)
      const auth = state.firebase.auth
      const forward = { [`/queues/${auth.uid}`]: null }
      Object.values(queue).forEach(({ value: block }) => {
        if (block.image && block.image.pendingUpload) {
          forward[
            `/pendingUploads/${block.image.pendingUpload}/locations/${block.id}`
          ] = null
        }
      })
      update({ forward })
      return dispatch(switchToggle('queue'))
    }

    dispatch(confirm('queue.confirmClear', action))
  })

const initialState = {
  selectedIndex: 0,
  columns: 11
}
export const queueReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SELECT_QUEUE_INDEX:
      return { ...state, selectedIndex: payload.index }
    case INCREASE_COLS:
      return { ...state, columns: Math.min(state.columns + 3, cols - 2) }
    case DECREASE_COLS:
      return { ...state, columns: Math.max(state.columns - 3, 2) }
    default:
      return state
  }
}
